import { type MutationOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'
import type { ReqUpdateCompanyMutation, ResCompany } from '@/lib/queries/business/v1/company/types'

export const updateCompanyMutation: MutationOptions<ResCompany, unknown, ReqUpdateCompanyMutation> = {
  mutationFn: (data) => {
    const { name, file: companyLogo, case_visibility, enableArchive } = data
    const payload = {
      name,
      file: companyLogo,
      case_visibility,
      enableArchive,
    } as ReqUpdateCompanyMutation

    return w.formData(payload).url(API_ENDPOINTS.business.v1.company.index).post().json()
  },
}
